import { render, staticRenderFns } from "./account-stat-data-list.vue?vue&type=template&id=5011c042"
import script from "./account-stat-data-list.vue?vue&type=script&lang=js"
export * from "./account-stat-data-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports